// Shared so the activity-trail UI ([components/assistant-ui/thread/activity-trail.tsx])
// and the analytics chat transport ([analytics-chat-transport.ts]) cannot drift
// on the format of the synthetic step ids used for streaming text parts and the
// transient "preparing" placeholder.
export const STREAMING_STEP_ID_PREFIX = '__streaming__';

// Synthetic id for the transient "preparing" row shown while the run is live
// but no real loader is in progress.
export const PREPARING_STEP_ID = '__preparing__';

export function streamingStepId(index: number): string {
  return `${STREAMING_STEP_ID_PREFIX}:${index}`;
}

export function isStreamingStepId(id: string): boolean {
  return id.startsWith(`${STREAMING_STEP_ID_PREFIX}:`);
}
